import React from "react";
import IconButton from "@mui/material/IconButton";
import ConfirmIcon from "./ConfirmIcon";

export default function ConfirmButton({ disabled, onClick }) {
    return (
        <IconButton
            disabled={disabled}
            onClick={onClick}
            sx={{
                width: "40px",
                height: "40px",
                backgroundColor: disabled ? "transparent" : "#4caf50",
                color: disabled ? "rgba(0, 0, 0, 0.26)" : "white",
                opacity: disabled ? 0.4 : 1,
                cursor: disabled ? "not-allowed" : "pointer",
                transition: "all 0.3s ease",
                "&:hover": {
                    backgroundColor: disabled ? "transparent" : "#45a049",
                },
                borderRadius: 1,
            }}
        >
            <ConfirmIcon disabled={disabled} />
        </IconButton>
    );
}
